// frontend/src/components/UdemyCourseSettings.js
import React, { useState, useEffect } from 'react';

const UdemyCourseSettings = ({ course, updateCourse }) => {
  const [courseSettings, setCourseSettings] = useState(course || {});

  useEffect(() => {
    setCourseSettings(course || {});
  }, [course]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCourseSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSave = () => {
    updateCourse(courseSettings);
    alert('Configuración del curso guardada.');
  };

  if (!course) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 text-center text-gray-600">
        Selecciona un curso para configurar sus ajustes.
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold mb-4">Configuración del curso: {course.title}</h2>

      <div className="space-y-6">
        <div>
          <label className="block text-gray-700 font-medium mb-2">Título del curso*</label>
          <input
            type="text"
            name="title"
            value={courseSettings.title || ''}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-2">Descripción*</label>
          <textarea
            name="description"
            value={courseSettings.description || ''}
            onChange={handleChange}
            rows="4"
            className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Categoría*</label>
            <select
              name="category"
              value={courseSettings.category || ''}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
              required
            >
              <option value="development">Desarrollo</option>
              <option value="business">Negocios</option>
              <option value="design">Diseño</option>
              <option value="marketing">Marketing</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Nivel*</label>
            <select
              name="level"
              value={courseSettings.level || ''}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
              required
            >
              <option value="beginner">Principiante</option>
              <option value="intermediate">Intermedio</option>
              <option value="advanced">Avanzado</option>
            </select>
          </div>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-2">Precio*</label>
          <div className="relative">
            <span className="absolute left-3 top-2">$</span>
            <input
              type="number"
              name="price"
              value={courseSettings.price || 0}
              onChange={handleChange}
              min="0"
              step="0.01"
              className="w-full pl-8 pr-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
              required
            />
          </div>
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="certificate"
            name="completionCertificate"
            checked={courseSettings.completionCertificate || false}
            onChange={handleChange}
            className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
          />
          <label htmlFor="certificate" className="ml-2 block text-gray-700">
            Ofrecer certificado de finalización
          </label>
        </div>
      </div>
      <button
        onClick={handleSave}
        className="mt-6 px-6 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
      >
        Guardar Configuración
      </button>
    </div>
  );
};

export default UdemyCourseSettings;